import React, { useEffect, useMemo, useState } from "react";
import Table from "../../../components/fouladyar/table";
import { useDispatch, useSelector } from "react-redux";
import {EmptyStateObject, filterStructure, tableStatics, tableStructure} from "./index";
import {ErrorToaster} from "../../../shared/toaster";
import {useTranslation} from "react-i18next";
import axios from "axios";
import {TableActionsStructure} from "./index";
import {IoAddOutline, IoArrowBackOutline} from "react-icons/io5";
import {useLocation, useNavigate, useParams} from "react-router";
import {BiReceipt} from "react-icons/bi";
import {LiaMoneyBillWaveSolid} from "react-icons/lia";




const WithdrawDetail = () => {

  const { t, i18n } = useTranslation();
  const {id} = useParams();
  const location = useLocation();
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [data, setData] = useState({
    status: 'success'
  });
  const [isLoading, setIsLoading] = useState(true);
  const [isApplyingFilter, setIsApplyingFilter] = useState(false);
  const [pagination, setPagination] = useState({
    itemPerPage: 7,
    currentPage: 1,
    totalItems: 0,
    lastUpdateBy: ''
  })
  const navigate = useNavigate();


  async function loadData() {
    const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/withdraw/${id}`, {
      headers: {authorization: `Bearer ${auth.token}`}
    })
    console.log('loaddata', res.data)
    if (res.data.statusCode === 200) {

      setData((prevData) => ({
        ...prevData,
        ...res.data.data,
      }));
      // setIsloading(false);
      return data;
    }

    return {};

  }


  useEffect(() => {
      loadData();
  }, []);



  return (
    <React.Fragment>


      <div className="grid-header">
        <div className="title-with-tab">
          <h3>تسویه حساب</h3>
        </div>
        <button className="btn small-button grid-action-btn" type="button" onClick={() => {
          navigate('/withdraw-list')
        }}>
          <IoArrowBackOutline size={17} color={"#49e7ad"}/>
        </button>
      </div>


      <div className="withdraw-status-container">

        <LiaMoneyBillWaveSolid size={80} color={"#38AF84"}/>
        <div className="payment-status-header">
          <h1 className={`${data.status === 'done' ? 'success' : (data.status === 'canceled' ? 'failed' : 'success')}`}>{t(data.status)}</h1>
          <h5> تسویه حساب  { data.status === 'done' ? "با موفقیت انجام شد" : (data.status === 'canceled' ? 'کنسل شد' : ((data.status === 'pending' ? 'در حال بررسی است' : 'نا مشخص است')))}</h5>
        </div>

        <div className="payment-status-values">
          <div className="d-flex flex-row justify-content-between payment-value-item">
            <div className="key">شماره حساب</div>
            <div className="value">{data?.extras?.account?.username}</div>
          </div>
          <div className="d-flex flex-row justify-content-between payment-value-item">
            <div className="key">شناسه متا</div>
            <div className="value">{data?.extras?.account?.metaapi_id}</div>
          </div>
          <div className="d-flex flex-row justify-content-between payment-value-item">
            <div className="key">آدرس ولت</div>
            <div className="value">{data?.extras?.wallet?.cardNumber}</div>
          </div>
          <div className="d-flex flex-row justify-content-between payment-value-item">
            <div className="key">شبکه ولت</div>
            <div className="value">{data?.extras?.wallet?.walletNetwork}</div>
          </div>
          <div className="d-flex flex-row justify-content-between payment-value-item">
            <div className="key">آدرس تراکنش</div>
            <div className="value">{data?.extras?.transactionUrl}</div>
          </div>
          <div className="d-flex flex-row justify-content-between payment-value-item">
            <div className="key">توضیحات</div>
            <div className="value">{data?.extras?.description}</div>
          </div>

          <div className="payment-divider"></div>

          <div className="d-flex flex-row justify-content-between payment-value-item">
            <div className="key">بالانس اولیه</div>
            <div className="value">{data?.extras?.initialCapital}</div>
          </div>
          <div className="d-flex flex-row justify-content-between payment-value-item">
            <div className="key">بالانس فعلی</div>
            <div className="value">{data?.extras?.balance}</div>
          </div>
          <div className="d-flex flex-row justify-content-between payment-value-item">
            <div className="key">ایکوئیتی</div>
            <div className="value">{data?.extras?.equity}</div>
          </div>
          <div className="d-flex flex-row justify-content-between payment-value-item">
            <div className="key">مبلغ واریزی</div>
            <div className="value">{data?.amount}</div>
          </div>



        </div>
      </div>

    </React.Fragment>
  );
};

export default WithdrawDetail;
